module.exports = __webpack_public_path__ + "static/media/kr.1fe47f22.svg";